export const ENDPOINTS_RESET_STATE = 'ENDPOINTS_RESET_STATE';
export const ENDPOINTS_CURRENT_ITEM = 'ENDPOINTS_CURRENT_ITEM';

export const ENDPOINTS_REQUEST_LOADING = 'ENDPOINTS_REQUEST_LOADING';
export const ENDPOINTS_REQUEST_SUCCESS = 'ENDPOINTS_REQUEST_SUCCESS';
export const ENDPOINTS_REQUEST_FAILED = 'ENDPOINTS_REQUEST_FAILED';

export const ENDPOINTS_CURRENT_ACTION = 'ENDPOINTS_CURRENT_ACTION';
export const ENDPOINTS_RESET_ACTION = 'ENDPOINTS_RESET_ACTION';